<template>
  <div v-if="visible" class="ph2-popup-mask" @click.self="close">
    <div class="ph2-popup-box">
      <img class="ph2-popup-img" :src="popupImg" @click="goTelegram" />
      <span class="ph2-popup-close" @click.stop="close" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useStore } from '@/store'
import { siteEnum } from '@/consts/SiteEnum'
import popupImg from '@/assets/images/ph2/ph2-affiliate-popup.png'

const TELEGRAM_URL = 'https://t.me/B9_GAME'

const store = useStore()
const visible = ref(false)

const close = () => {
  visible.value = false
}

const goTelegram = () => {
  window.open(TELEGRAM_URL, '_blank', 'noopener')
  close()
}

const PENDING_KEY = 'ph2AffiliatePopupPending'

onMounted(() => {
  let justLoggedIn = false
  try {
    justLoggedIn = !!sessionStorage.getItem(PENDING_KEY)
    sessionStorage.removeItem(PENDING_KEY)
  } catch (e) {
    return
  }
  if (!justLoggedIn || Number(store.state.user.siteId) !== Number(siteEnum.PH2)) {
    return
  }
  visible.value = true
})
</script>

<style lang="scss" scoped>
.ph2-popup-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
}

.ph2-popup-box {
  position: relative;
  width: min(92vw, 560px);
}

.ph2-popup-img {
  display: block;
  width: 100%;
  height: auto;
  cursor: pointer;
}

// invisible hit area over the X baked into the image
.ph2-popup-close {
  position: absolute;
  top: 8.5%;
  right: 8.5%;
  width: 7%;
  aspect-ratio: 1;
  cursor: pointer;
}
</style>
